
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Tiktok'
})
export default class Tiktok extends Vue {}
